import type { GetStaticProps, NextPage } from "next";
import { PlatformPage } from "src/domains/shared/components/Home/Platform/PlatformPage";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";

const Accurate: NextPage = () => (
  <SiteLayout>
    <PlatformPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Accurate;
